<template>
    <div class="ah-page vendor-page">
        <div class="page-header bottom-margin" id="vender-page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>客戶管理</h1>
                    </div>
                    <div class="actions" style="display: flex; justify-content: flex-end">
                        <el-input
                            class="search"
                            clearable
                            placeholder="名稱、統編"
                            prefix-icon="el-icon-search"
                            v-model="conditions.keyword"
                            @keyup.enter.native="searchSubmit"
                            @clear="updateData"
                            style="width: 250px; margin-right: 10px"
                        ></el-input>
                        <div style="margin-right: 10px">
                            <!-- <el-button @click="onUploadSheet">批次匯入</el-button> -->
                            <el-button @click="newImportDialogVisible = true">批次匯入</el-button>
                        </div>
                        <el-button type="highlight" @click="handleAddBtnClick">新增客戶</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-header gray small">
                    <div class="panel-title">
                        <div style="text-align: right; font-weight: normal; font-size: 10.5pt">客戶總數：{{ total }}</div>
                    </div>
                </div>
                <div class="panel-body">
                    <ahDataTable
                        tableKey="vendor-data-table"
                        :columns="columns"
                        :data="datas"
                        :is-row-click="false"
                        v-loading="status == 'loading'"
                        :indexStart="conditions.pageSize * (conditions.currPage - 1) + 1"
                        :showRefreshButton="true"
                        @refresh="updateData"
                    >
                        <template v-slot:voo="scope">
                            <span class="idx clickable-col-text" @click="handleDataRowClick(scope.row)">{{ scope.row.voo }}</span>
                        </template>
                        <template v-slot:fnam="scope">
                            <div class="strong clickable-col-text" @click="handleDataRowClick(scope.row)">{{ scope.row.fnam }}</div>
                        </template>
                        <template v-slot:bsn="scope">
                            <div style="color: #888; font-size: 10pt">{{ scope.row.bsn }}</div>
                        </template>
                        <template v-slot:accountLast5Number="scope">
                            <div>{{ scope.row.accountLast5Number }}</div>
                        </template>
                        <template v-slot:note="scope">
                            <div style="color: #333; font-size: 10pt">{{ scope.row.note }}</div>
                        </template>
                    </ahDataTable>
                    <el-pagination
                        :small="isMobile()"
                        layout="prev, pager, next"
                        :page-size.sync="conditions.pageSize"
                        :total.sync="totalDataCount"
                        :current-page.sync="conditions.currPage"
                        @current-change="handlePaginationChange"
                        class="pagination"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
        <VendorDetailDialog ref="vendorDetailDialog" :visible="detailDialogVisible" :sno="detailDialogSno" @close="handleDetailDialogClose" />
        <VendorBatchImportDialog :visible="batchImportDialog.visible" :data="batchImportDialog.data" @close="onBatchImportDialogClose" />
        <VendorNewImportDialog :visible="newImportDialogVisible" @close="onNewImportDialogClose" />
    </div>
</template>
<script>
import ahDataTable from '@/components/ui/ahDataTable.vue';
import VendorDetailDialog from './VendorDetailDialog.vue';
import VendorBatchImportDialog from './VendorBatchImportDialog.vue';
import VendorNewImportDialog from './VendorNewImportDialog.vue';

export default {
    name: 'VendorPage',
    components: { VendorDetailDialog, VendorBatchImportDialog, VendorNewImportDialog, ahDataTable },
    data() {
        return {
            status: '',
            detailDialogVisible: false,
            detailDialogSno: null,
            columns: {
                index: {
                    label: '#',
                },
                voo: {
                    label: '系統編號',
                    width: 105,
                },
                bsn: {
                    label: '統編',
                    width: 105,
                },
                fnam: {
                    label: '全名',
                    disableHide: true,
                },
                accountLast5Number: {
                    label: '匯款帳號後五碼',
                    width: 130,
                },
                note: {
                    label: '備註',
                },
            },
            datas: [],
            total: null,
            totalDataCount: 0,
            conditions: {
                currPage: 1,
                pageSize: 25,
                keyword: '',
            },
            batchImportDialog: {
                visible: false,
                data: null,
            },
            newImportDialogVisible: false,
        };
    },
    mounted() {
        this.updateData();
    },
    methods: {
        // 按下新增按鈕
        handleAddBtnClick() {
            this.$router.push({ name: 'vendor-add' });
        },

        // 按下表格一行
        handleDataRowClick(data) {
            this.detailDialogSno = data.sno;
            this.detailDialogVisible = true;
        },

        // 關閉客戶資料後
        handleDetailDialogClose(refresh) {
            this.detailDialogSno = null;
            this.detailDialogVisible = false;
            if (refresh) {
                this.updateData();
            }
        },

        // 分頁選單點選事件
        handlePaginationChange() {
            this.updateData();
        },

        // 搜尋送出
        searchSubmit() {
            this.updateData();
        },

        // 更新客戶（顯示頁面時觸發）
        updateData() {
            this.status = 'loading';
            this.errorMsg = '';

            // 開始取得資料
            this.$api({
                url: `VendorManagementPage/GetVendorList?PageSize=${this.conditions.pageSize}&PageNum=${this.conditions.currPage}&keyword=${this.conditions.keyword}`,
                method: 'GET',
            })

                // 取得成功
                .then((resp) => {
                    this.status = 'success';

                    console.log('Vendors', resp);

                    // 更新資料
                    this.datas = resp.data.items;
                    this.total = resp.data.totalNum;

                    // 所有資料筆數
                    this.totalDataCount = resp.data.totalNum;
                });
        },

        onUploadSheet() {
            this.batchImportDialog.visible = true;
        },
        onBatchImportDialogClose(refresh) {
            this.batchImportDialog.visible = false;
            if (refresh) this.updateData();
        },
        onNewImportDialogClose(refresh) {
            this.newImportDialogVisible = false;
            if (refresh) this.updateData();
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.vendor-page {
    .clickable-col-text {
        display: inline-block;
        cursor: pointer;

        &:hover {
            text-decoration: underline;
        }
    }
}
</style>
